export const ATTR_TYPE_DEPENDENT = 'DEPENDENT'
export const ATTR_TYPE_INDEPENDENT = 'INDEPENDENT'
export const DEFAULT_USE_CASE = 'PRIVATE'
